var map = {
	"./admin/pattern": "./app/javascript/images/admin/pattern.png",
	"./admin/pattern.png": "./app/javascript/images/admin/pattern.png",
	"./alexander": "./app/javascript/images/alexander.png",
	"./alexander.png": "./app/javascript/images/alexander.png",
	"./anna": "./app/javascript/images/anna.png",
	"./anna.png": "./app/javascript/images/anna.png",
	"./boat": "./app/javascript/images/boat.png",
	"./boat.png": "./app/javascript/images/boat.png",
	"./cloud": "./app/javascript/images/cloud.png",
	"./cloud.png": "./app/javascript/images/cloud.png",
	"./clouds": "./app/javascript/images/clouds.png",
	"./clouds.png": "./app/javascript/images/clouds.png",
	"./denis": "./app/javascript/images/denis.png",
	"./denis.png": "./app/javascript/images/denis.png",
	"./design": "./app/javascript/images/design.png",
	"./design.png": "./app/javascript/images/design.png",
	"./development": "./app/javascript/images/development.png",
	"./development.png": "./app/javascript/images/development.png",
	"./dot": "./app/javascript/images/dot.png",
	"./dot.png": "./app/javascript/images/dot.png",
	"./evgeny": "./app/javascript/images/evgeny.png",
	"./evgeny.png": "./app/javascript/images/evgeny.png",
	"./favicon": "./app/javascript/images/favicon.png",
	"./favicon.ico": "./app/javascript/images/favicon.ico",
	"./favicon.png": "./app/javascript/images/favicon.png",
	"./flags": "./app/javascript/images/flags.png",
	"./flags.png": "./app/javascript/images/flags.png",
	"./ground": "./app/javascript/images/ground.png",
	"./ground.png": "./app/javascript/images/ground.png",
	"./gspmain": "./app/javascript/images/gspmain.jpg",
	"./gspmain.jpg": "./app/javascript/images/gspmain.jpg",
	"./ivan": "./app/javascript/images/ivan.png",
	"./ivan.png": "./app/javascript/images/ivan.png",
	"./kc_grey": "./app/javascript/images/kc_grey.png",
	"./kc_grey.png": "./app/javascript/images/kc_grey.png",
	"./kc_logo_small": "./app/javascript/images/kc_logo_small.png",
	"./kc_logo_small.png": "./app/javascript/images/kc_logo_small.png",
	"./lighthouse": "./app/javascript/images/lighthouse.png",
	"./lighthouse.png": "./app/javascript/images/lighthouse.png",
	"./list-style-image": "./app/javascript/images/list-style-image.png",
	"./list-style-image.png": "./app/javascript/images/list-style-image.png",
	"./logo": "./app/javascript/images/logo.png",
	"./logo.png": "./app/javascript/images/logo.png",
	"./map": "./app/javascript/images/map.png",
	"./map.png": "./app/javascript/images/map.png",
	"./mountines_1": "./app/javascript/images/mountines_1.png",
	"./mountines_1.png": "./app/javascript/images/mountines_1.png",
	"./mountines_2": "./app/javascript/images/mountines_2.png",
	"./mountines_2.png": "./app/javascript/images/mountines_2.png",
	"./projects/fat__right": "./app/javascript/images/projects/fat__right.png",
	"./projects/fat__right.png": "./app/javascript/images/projects/fat__right.png",
	"./projects/golikovvv": "./app/javascript/images/projects/golikovvv.jpg",
	"./projects/golikovvv.jpg": "./app/javascript/images/projects/golikovvv.jpg",
	"./ptrn1": "./app/javascript/images/ptrn1.png",
	"./ptrn1.png": "./app/javascript/images/ptrn1.png",
	"./rocket": "./app/javascript/images/rocket.png",
	"./rocket.png": "./app/javascript/images/rocket.png",
	"./sky": "./app/javascript/images/sky.png",
	"./sky.png": "./app/javascript/images/sky.png",
	"./sky1": "./app/javascript/images/sky1.jpg",
	"./sky1.jpg": "./app/javascript/images/sky1.jpg",
	"./smoke": "./app/javascript/images/smoke.png",
	"./smoke.png": "./app/javascript/images/smoke.png",
	"./sun_haze": "./app/javascript/images/sun_haze.png",
	"./sun_haze.png": "./app/javascript/images/sun_haze.png",
	"./swipe": "./app/javascript/images/swipe.gif",
	"./swipe.gif": "./app/javascript/images/swipe.gif",
	"./training": "./app/javascript/images/training.png",
	"./training.png": "./app/javascript/images/training.png",
	"./wave1": "./app/javascript/images/wave1.png",
	"./wave1.png": "./app/javascript/images/wave1.png",
	"./wave2": "./app/javascript/images/wave2.png",
	"./wave2.png": "./app/javascript/images/wave2.png",
	"./wave3": "./app/javascript/images/wave3.png",
	"./wave3.png": "./app/javascript/images/wave3.png",
	"./wave4": "./app/javascript/images/wave4.png",
	"./wave4.png": "./app/javascript/images/wave4.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";